import { useState, useRef } from "react";
// import { useNavigate } from "react-router";
// import { Link } from "react-router-dom";

// material-ui
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";

// project import
import Avatar from "components/@extended/Avatar";
import useAuth from "hooks/useAuth";
import { useGetMenuMaster } from "api/menu";

// assets
// import { ArrowDown2, ArrowRight2 } from "iconsax-react";

import { Typography } from "@mui/material";
import Profile from "../../Header/HeaderContent/Profile";
import { canAccessAdminPanel } from "utils/adminAccess";
import { useMediaQuery } from "@mui/system";
import { useGetUser } from "api/user";
import Loader from "components/Loader";
// import { TITLE_MAPPING } from "dataClient/Titles";

// Define title prefixes
const TITLE_PREFIX = {
  'PROF': 'Pr',
  'DOC': 'Dr',
  'ETU': '',
  'OTHER': ''
};

// const ExpandMore = styled(IconButton, {
//   shouldForwardProp: (prop) =>
//     prop !== "theme" && prop !== "expand" && prop !== "drawerOpen",
// })(({ theme, expand, drawerOpen }) => ({
//   transform: !expand ? "rotate(0deg)" : "rotate(-90deg)",
//   marginLeft: "auto",
//   color: theme.palette.secondary.dark,
//   transition: theme.transitions.create("transform", {
//     duration: theme.transitions.duration.shortest,
//   }),
//   ...(!drawerOpen && {
//     opacity: 0,
//     width: 50,
//     height: 50,
//   }),
// }));

// ==============================|| LIST - USER ||============================== //

export default function UserList() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const { user: userData, userLoading } = useGetUser();
  const { user } = useAuth();

  const downLG = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  
  // State and ref for Profile menu
  const [profileOpen, setProfileOpen] = useState(false);
  const profileAnchorRef = useRef(null);
  
  const handleListItemClick = () => {
    setProfileOpen((prevOpen) => !prevOpen);
  };

  function stringAvatar(firstName, lastName) {
    if (!firstName || !lastName)
      return {
        sx: {
          bgcolor: "primary.100",
          fontWeight: 700,
          fontSize: 12,
        },
      };

    return {
      sx: {
        bgcolor: "primary.100",
        fontWeight: 700,
        fontSize: 12,
      },
      children: `${firstName[0]}${lastName[0]}`.toUpperCase(),
    };
  }
  
  // Function to get formatted name with title prefix
  const getFormattedName = (userData) => {
    if (!userData) return '';
    
    const titlePrefix = userData.title ? TITLE_PREFIX[userData.title] || '' : '';
    const name = userData.name || '';
    
    return titlePrefix ? `${titlePrefix} ${name}` : `${name}`
  };

  if (userLoading) return <Loader />;

  // Add a simple check for userData
  if (!userData) {
    return (
      <Box sx={{ p: 1, px: !drawerOpen ? 1.25 : 2, minWidth: 270 }}>
        <Typography>No user data available</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ px: 1}}>
      <List disablePadding>
        <ListItem
          disablePadding
          component="div"
          onClick={handleListItemClick}
          ref={profileAnchorRef}
          secondaryAction={
            <Profile 
              admin={canAccessAdminPanel(user)} 
              open={profileOpen}
              setOpen={setProfileOpen}
              userData={userData}
              anchorRef={profileAnchorRef}
              downLG={downLG}
            />
          }
          sx={{
            ...{ display: "flex", justifyContent: "space-between", cursor: "pointer" },
            "& .MuiListItemSecondaryAction-root": {
              right: 0,
            },
          }}
        >
          {
            !downLG ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 ,textWrap: 'nowrap', pr: 5}}>
                <ListItemAvatar sx={{ minWidth: 40 }}>
                  <Box sx={{ position: "relative", display: "inline-flex", width: 40, height: 40 }}>
                    {!user?.is_verified && (
                      <Box
                        sx={{
                          position: "absolute",
                          inset: -3,
                          borderRadius: "50%",
                          border: "2.5px solid #f5a623",
                        }}
                      />
                    )}
                    <Avatar
                      {...stringAvatar(userData?.first_name, userData?.last_name)}
                      src={userData?.profile_image_url}
                      sx={{ width: 40, height: 40, fontSize: 14 }}
                    />
                    {!user?.is_verified && (
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: -3,
                          right: -3,
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          bgcolor: "#f57c00",
                          border: "2px solid #fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.6rem",
                          fontWeight: 900,
                          color: "#fff",
                          lineHeight: 1,
                        }}
                      >
                        !
                      </Box>
                    )}
                  </Box>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "bold", color: "black" }}
                    >
                      {getFormattedName(user)}
                    </Typography>
                  }
                  secondary={user?.profession_name || ''}
                  sx={{
                    '& .MuiListItemText-secondary': {
                      marginTop: -.7,
                    }
                  }}
                />
              </Box>
            ) : (
              <Box sx={{ width: '25px'}}>

              </Box>
            )
          }
        </ListItem>
      </List>
    </Box>
  );
}
